import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Button,
  Dialog,
  DialogContent,
  useMediaQuery,
  CircularProgress,
  useTheme,
} from "@mui/material";
import { Field, getFormSyncErrors, getFormValues, reduxForm } from "redux-form";
import { Link } from "react-router-dom";
import { renderTextField } from "components/FormFields/FieldTypes";
import { PhoneNumberRequired } from "components/FormFields/validators";
import { phone as phoneFormatter } from "components/FormFields/formatters";
import { phone as phoneValidator } from "components/FormFields/normalizers";
import { connect } from "react-redux";
import { homeActions, gaugeActions } from "actions";

const SendTextMessagePopUp = (props) => {
  const {
    showSendTextMessage,
    onCancel,
    formErrors,
    sendTextMessage,
    formValues,
    brandDetailsNew,
    genericDetails,
    sendTextMessageInfo,
    resetSendTextInfo,
    showTextCoupon = false,
    updateGTMDataLayer,
    organizationInfo,
    couponData = null,
    fromSendSavinsgPOS = false,
    getBrandDetailsNew,
    productType = null,
    getGenericDetails,
    sendTextMessageInfoIsProgress,
    fromBranded = false,
    autoSubmit = false,
    autoSubmitData = null,
  } = props;
  const theme = useTheme();

  const [showSuccess, setShowSuccess] = useState(false);
  const [showFailure, setShowFailure] = useState(false);
  const [triggerCopay, setTriggerCopay] = useState(false);

  const matchesMinWidth = useMediaQuery("(max-width:600px)");
  const isPOSTemplate =
    organizationInfo?.type?.toLowerCase() === "p" &&
    organizationInfo?.app?.appCode?.toLowerCase() == "hcp";
  const defaultInsuranceId = localStorage.getItem("defaultInsuranceId");
  const storedZipData = JSON.parse(localStorage.getItem("storedZipData"));

  useEffect(() => {
    resetSendTextInfo();
    updateGTMDataLayer({
      event: "Get_savings_share_text_attempt",
      action: "attempting text share coupon",
      page: "Copay Coupon Card",
      screen: "Copay Coupon Card",
      screen_referrer: "Copay Coupon Card",
      adjudicationId: brandDetailsNew?.id || genericDetails?.id,
    });
    return () => {
      resetSendTextInfo();
    };
  }, []);

  useEffect(() => {
    setShowFailure(false);
    setShowSuccess(false);
    if (
      sendTextMessageInfo &&
      sendTextMessageInfo.data &&
      sendTextMessageInfo.success
    ) {
      setShowSuccess(true);
    }
    if (
      Object.keys(sendTextMessageInfo).length &&
      !sendTextMessageInfo.data &&
      !sendTextMessageInfo.success
    ) {
      setShowFailure(true);
    }
  }, [sendTextMessageInfo]);

  const onSubmitPopUpData = async () => {
    if (autoSubmit) {
      sendTextMessage({ ...autoSubmitData });
    } else {
      sendTextMessage({
        ...formValues,
        adjudicationId: brandDetailsNew?.id || genericDetails?.id,
      });
    }
    updateGTMDataLayer({
      event: "Get_savings_share_text",
      action: "completed text share coupon",
      page: "Copay Coupon Card",
      screen: "Copay Coupon Card",
      screen_referrer: "Copay Coupon Card",
      ...formValues,
      adjudicationId: brandDetailsNew?.id || genericDetails?.id,
    });
  };

  useEffect(() => {
    if (autoSubmit && autoSubmitData) {
      onSubmitPopUpData();
    }
  }, [autoSubmit]);

  useEffect(() => {
    if ((brandDetailsNew?.id || genericDetails?.id) && triggerCopay) {
      onSubmitPopUpData();
      setTriggerCopay(false);
    }
  }, [triggerCopay, brandDetailsNew, genericDetails]);

  const onSuccessDone = () => {
    setShowSuccess(false);
    onCancel();
  };

  const onFailedDone = () => {
    setShowFailure(false);
    onCancel();
  };

  const renderLayout = () => {
    return (
      <DialogContent
        sx={{
          padding: "20px 24px 5px 24px",
          paddingLeft: matchesMinWidth ? "24px" : "40px",
          paddingRight: matchesMinWidth ? "24px" : "40px",
          paddingTop: showTextCoupon ? "0px" : undefined,
        }}
      >
        {sendTextMessageInfoIsProgress ? (
          <div
            style={{
              height: "300px",
              display: "flex",
              alignItems: "center",
              width: "100%",
              justifyContent: "center",
            }}
          >
            <CircularProgress
              style={{ color: theme?.palette?.secondary?.main }}
            />
          </div>
        ) : !showSuccess && !showFailure ? (
          <Box
            component="div"
            sx={{
              textAlign: "center",
              width: matchesMinWidth ? undefined : "500px",
              padding: matchesMinWidth
                ? "16px 5px 0px 5px"
                : showTextCoupon
                ? "20px 40px 0px 40px"
                : "40px",
              borderRadius: "20px",
            }}
          >
            {!fromBranded && !showTextCoupon && (
              <>
                <Box
                  sx={{ textAlign: showTextCoupon ? "center" : "center" }}
                  mb={showTextCoupon ? 2 : 4}
                >
                  <Typography
                    variant="h2LatoBold"
                    sx={{
                      fontFamily: "Lato",
                      fontWeight: "bold",
                    }}
                  >
                    {isPOSTemplate
                      ? "Send this coupon by text"
                      : "Text me coupon to show pharmacist"}
                  </Typography>
                </Box>

                <Box mb={3}>
                  <Typography
                    variant="h2LatoMedium"
                    sx={{
                      fontWeight: 500,
                      fontSize: 16,
                      textAlign: "center",
                      color: "#607277",
                    }}
                  >
                    Enter the phone number to text this coupon:
                  </Typography>
                </Box>
              </>
            )}
            <Box mb={5}>
              <Field
                name="phoneNumber"
                //                isRequired
                component={renderTextField}
                label="Mobile phone number"
                validate={[PhoneNumberRequired]}
                format={phoneFormatter}
                normalize={phoneValidator}
              />
            </Box>
            <Box mb={3} sx={{ textAlign: "center" }}>
              <Typography variant="h4LatoBold" sx={{ fontSize: "12px" }}>
                By continuing to use this website, you agree to the Cuverd{" "}
                <Box
                  component={Link}
                  to="/terms-and-conditions"
                  sx={
                    {
                      //textDecoration: "none",
                    }
                  }
                >
                  <Typography
                    component={"span"}
                    sx={{ fontSize: "12px" }}
                    variant="h3LatoBoldNew"
                  >
                    Terms and Conditions
                  </Typography>
                </Box>{" "}
                and{" "}
                <Box
                  component={Link}
                  to="/privacy-policy"
                  sx={
                    {
                      //textDecoration: "none",
                    }
                  }
                >
                  <Typography
                    component={"span"}
                    sx={{ fontSize: "12px" }}
                    variant="h3LatoBoldNew"
                  >
                    Privacy Policy
                  </Typography>
                </Box>{" "}
              </Typography>
            </Box>
            <Box mb={!fromBranded ? 4 : 0}>
              <Button
                variant="large"
                type="button"
                onClick={() => {
                  if (fromSendSavinsgPOS) {
                    if (
                      couponData !== null &&
                      productType === "branded" &&
                      !brandDetailsNew?.id
                    ) {
                      getBrandDetailsNew({
                        offerId: couponData.offerId,
                        insuranceId: defaultInsuranceId,
                        zipCode: storedZipData?.zipCode,
                        quantity: couponData.quantity || 0,
                        productDetailId: couponData.productDetailId,
                        pharmacyLocationId: couponData.pharmacyLocationId,
                        prescriptionFlag: "N",
                      });
                    }
                    if (
                      couponData !== null &&
                      productType === "generic" &&
                      !genericDetails?.id
                    ) {
                      getGenericDetails({
                        productDetailId: couponData?.productDetailId,
                        offerId: couponData?.offerId,
                        insuranceId: defaultInsuranceId,
                        pbmPharmacyLocationId:
                          couponData?.pbmPharmacyLocationId,
                        zipCode: couponData?.zipCode || storedZipData?.zipCode,
                        quantity: couponData?.quantity,
                        pbmProductDetailId: couponData?.pbmProductDetailId,
                        pharmacyGroupPbmId: couponData?.pharmacyGroupPbmId,
                        pbmId: couponData?.pbmId,
                      });
                    }
                    setTriggerCopay(true);
                  } else {
                    onSubmitPopUpData();
                  }
                }}
                disabled={
                  Object.keys(formErrors).length || !formValues?.phoneNumber
                    ? true
                    : false
                }
                sx={{
                  backgroundColor: Object.keys(formErrors).length
                    ? "#e6e6e6"
                    : `${organizationInfo?.colorSchemeJson?.primaryButtonColor}`,
                  width: matchesMinWidth ? undefined : "100%",
                  fontSize: matchesMinWidth ? "14px" : undefined,
                  minWidth: matchesMinWidth ? "200px" : undefined,
                  color: Object.keys(formErrors).length
                    ? "#637276"
                    : `${organizationInfo?.colorSchemeJson?.primaryButtonTextColor} !important`,
                  boxShadow: "none",
                  "&:hover": {
                    backgroundColor: `${organizationInfo?.colorSchemeJson?.primaryButtonColor}`,
                  },
                }}
              >
                SEND COUPON
              </Button>
            </Box>
            {!fromBranded && (
              <Box mx="auto" sx={{ width: "100%" }}>
                <Button
                  variant="text"
                  sx={{
                    width: matchesMinWidth ? undefined : "100%",
                    fontSize: matchesMinWidth ? "14px" : undefined,
                    minWidth: matchesMinWidth ? "200px" : undefined,
                    textDecoration: "underline",
                    //color: `${organizationInfo?.colorSchemeJson?.primaryButtonTextColor} !important`,
                  }}
                  onClick={onCancel}
                >
                  CANCEL
                </Button>
              </Box>
            )}
          </Box>
        ) : (
          <Box sx={{ textAlign: "center" }}>
            {showSuccess ? (
              <Box>
                <Box mb={4} mt={2}>
                  <Typography variant="h2LatoBold">Coupon sent!</Typography>
                </Box>
                <Box mb={7}>
                  <Typography variant="h2LatoMedium">
                    You have successfully sent a coupon to{" "}
                    {phoneFormatter(
                      formValues?.phoneNumber || autoSubmitData?.phoneNumber
                    )}
                    .
                  </Typography>
                </Box>
                {!fromBranded && (
                  <Box mb={4}>
                    <Button
                      variant="large"
                      sx={{
                        minWidth: { xs: "150px", sm: "100%", md: undefined },
                      }}
                      onClick={() => onSuccessDone()}
                    >
                      DONE
                    </Button>
                  </Box>
                )}
              </Box>
            ) : null}
            {showFailure ? (
              <Box>
                <Box mt={3}>
                  <Typography variant="h2LatoBold">Send Text Error</Typography>
                </Box>
                <Box my={3}>
                  <Typography variant="h2LatoMedium">
                    {sendTextMessageInfo?.message}
                  </Typography>
                </Box>
                <Box>
                  <Button variant="large" onClick={() => onFailedDone()}>
                    OK
                  </Button>
                </Box>
              </Box>
            ) : null}
          </Box>
        )}
      </DialogContent>
    );
  };

  return (
    <>
      {showTextCoupon ? (
        renderLayout()
      ) : (
        <Box>
          <Dialog
            open={showSendTextMessage}
            className="app-dialog"
            onClose={onCancel}
            sx={{
              display: !autoSubmit
                ? "block"
                : showSuccess || showFailure
                ? "block"
                : "none",
            }}
          >
            {renderLayout()}
          </Dialog>
        </Box>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    formErrors: getFormSyncErrors("SEND_TEXT_PHONE_NUMBER_FORM")(state) || {},
    formValues: getFormValues("SEND_TEXT_PHONE_NUMBER_FORM")(state),
    sendTextMessageInfo: state.sendTextMessageInfo.data,
    brandDetailsNew: state.brandDetailsNew.data,
    genericDetails: state.genericDetails.data,
    organizationInfo: state.organizationInfo.data || {},
    sendTextMessageInfoIsProgress: state.sendTextMessageInfo.isProgress,
  };
};

const mapDispatchToProps = {
  sendTextMessage: (params) => homeActions.sendTextMessage(params),
  resetSendTextInfo: () => homeActions.resetSendTextInfo(),
  updateGTMDataLayer: (param) => homeActions.updateGTMDataLayer(param),
  getBrandDetailsNew: (params) => gaugeActions.getBrandDetailsNew(params),
  getGenericDetails: (params) => gaugeActions.getGenericDetails(params),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: "SEND_TEXT_PHONE_NUMBER_FORM",
  })(SendTextMessagePopUp)
);
